<template>
  <footer class="mt-auto flex w-full flex-col">
    <div
      class="gap-sm laptop:flex-row p-lg laptop:gap-xxl laptop:items-end laptop:justify-center flex flex-col justify-end"
    >
      <div class="flex items-center justify-center">
        <GLink to="/cgu">Conditions générales d'utilisation</GLink>
      </div>
      <div class="flex items-center justify-center">
        <GLink to="/confidentialite">Politique de confidentialité</GLink>
      </div>
      <div class="flex items-center justify-center">
        <GLink to="https://info.agenda.org/"> Nous contacter </GLink>
      </div>
    </div>
  </footer>
</template>
